// extracted by mini-css-extract-plugin
export default {"navItem":"styles_navItem__FwuCs","navItem_clicked":"styles_navItem_clicked__3LSkQ"};